<template>
    <div class="checkbox">
        <label>
            <input
                type="checkbox"
                :disabled="!enabled"
                v-model="controlValue.data"
                @change="onChange"
            />
            {{ label }}
        </label>
    </div>
</template>

<script>
import {useJsonFormsControl} from "@jsonforms/vue2";
import { ref, watchEffect } from "vue";

export default {
    name: "CheckboxRenderer",
    props: {
        schema: {
            required: true,
            type: [Object, Boolean]
        },
        uischema: {
            required: true,
            type: Object
        },
        path: {
            required: true,
            type: String
        },
        enabled: {
            required: false,
            type: Boolean,
            default: undefined
        },
        renderers: {
            required: false,
            type: Array,
            default: undefined
        },
        cells: {
            required: false,
            type: Array,
            default: undefined
        },
        config: {
            required: false,
            type: Object,
            default: undefined
        }
    },
    setup(props) {
        const { control, handleChange } = useJsonFormsControl(props)
        const propertyKey = ref(null)

        watchEffect(() => {
            if (props.schema && props.schema.properties) {
                propertyKey.value = Object.keys(props.schema.properties)[0] || null
            }
        });

        return {
            controlValue: control,
            propertyKey,
            onChange(event) {
                if (propertyKey.value) {
                    handleChange(props.path, { [propertyKey.value]: event.target.checked })
                }
            },
        };
    },
    computed: {
        label() {
            return this.schema.properties[Object.keys(this.schema.properties)[0]].title
        }
    }
};
</script>
